import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle } from 'lucide-react';
const notifications = [{
  name: 'María',
  city: 'Buenos Aires'
}, {
  name: 'Sofía',
  city: 'Córdoba'
}, {
  name: 'Valentina',
  city: 'Rosario'
}, {
  name: 'Camila',
  city: 'Mendoza'
}, {
  name: 'Lucía',
  city: 'La Plata'
}, {
  name: 'Martina',
  city: 'Mar del Plata'
}, {
  name: 'Florencia',
  city: 'Salta'
}, {
  name: 'Agustina',
  city: 'San Miguel de Tucumán'
}, {
  name: 'Carolina',
  city: 'Santa Fe'
}, {
  name: 'Rocío',
  city: 'Neuquén'
}];
export function SocialProofPopup() {
  const [currentNotification, setCurrentNotification] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const showNotification = () => {
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 3500);
    };
    const interval = setInterval(() => {
      setCurrentNotification(prev => (prev + 1) % notifications.length);
      showNotification();
    }, 6000);
    // Show first notification after 2 seconds
    setTimeout(showNotification, 2000);
    return () => clearInterval(interval);
  }, []);
  const notification = notifications[currentNotification];
  return <AnimatePresence data-id="element-162">
      {isVisible && <motion.div initial={{
      opacity: 0,
      x: -100,
      y: 20
    }} animate={{
      opacity: 1,
      x: 0,
      y: 0
    }} exit={{
      opacity: 0,
      x: -100
    }} transition={{
      duration: 0.4,
      ease: 'easeOut'
    }} className="fixed bottom-6 left-6 z-50 max-w-sm" data-id="element-163">
          <div className="bg-white rounded-lg shadow-2xl border-2 border-green-400 p-4 flex items-start gap-3" data-id="element-164">
            <div className="bg-green-500 rounded-full p-1 flex-shrink-0" data-id="element-165">
              <CheckCircle className="w-5 h-5 text-white" data-id="element-166" />
            </div>
            <div data-id="element-167">
              <p className="text-sm font-bold text-gray-900" data-id="element-168">
                {notification.name} de {notification.city}
              </p>
              <p className="text-xs text-gray-600" data-id="element-169">
                acaba de comprar este libro digital
              </p>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}